import { useQuery } from 'react-query';
import { superAdminKeys } from './superAdminKeys';
import {
  USER_INVITES_ROLES_FILTER,
  USER_INVITES_STATUS_FILTER,
} from 'app/pages/admin/customers/components/manageInvites/types';
import { EXPRESS_API } from 'configs/api/expressApi';

export interface IUserInvitesResponse {
  users: UserInvite[];
  count: number;
}

interface ChildUser {
  parentUserId: number;
}

export interface UserInvite {
  id: number;
  customerId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone1: string;
  cellPhone: string;
  userInvite: UserInviteOptions | null;
  bouncedEmail: string;
  access: string;
  mlAutoCreated: boolean;
  parentUserId?: number;
  childUsers?: ChildUser[];
}

interface UserInviteScheduler {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
}

interface UserInviteOptions {
  status: string;
  failReason?: string | null;
  deliveryTime: null | string;
  deliveryUnixTimestamp: number;

  scheduler: UserInviteScheduler;
}

export type UserInvitesParams = {
  customerId?: number;
  start?: number;
  limit?: number;
  search?: string;
  sortKey?: string;
  order?: string;
  status?: USER_INVITES_STATUS_FILTER;
  role?: USER_INVITES_ROLES_FILTER;
  refetchInterval?: number;
};

const getCustomerUserInvites = async (
  params: UserInvitesParams
): Promise<IUserInvitesResponse> => {
  const { customerId, refetchInterval: _, ...rest } = params;

  return (
    await EXPRESS_API.get(`/superadmin/customers/${customerId}/user-invites`, {
      params: rest,
    })
  ).data as IUserInvitesResponse;
};

export const useUserInvitesQuery = (params: UserInvitesParams) => {
  return useQuery(
    superAdminKeys.invite_users(params),
    () => getCustomerUserInvites(params),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!params.customerId,
      refetchInterval: params.refetchInterval || false,
    }
  );
};
